<template lang="pug">
  section.text-center
    img.logo(src="@/assets/images/branding/logo_icon_grey.svg", alt="Wall collective logo icon")
    p.mt-5 {{ text || 'NO ITEMS' }}
</template>

<script>

export default {
  name: 'NoContent',
  data() {
    return {
    };
  },
  props: ['text'],
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.logo {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Nothing.vue